export enum CustomErrorCode {
  InviteTeamMemberError = 'InviteTeamMemberError',
}
